/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by randysorensen on 8/10/16,
 * Refactored by kyang on 9/25/2019
 */

function MetadataItemsGridController (
    this: JS5Object,
    _: JS5Object,
    $q: JS5Object,
    $scope: JS5Object,
    MetadataEditService: JS5Object,
    ModalService: JS5Object,
) {

    //======//
    // Grid //
    //======//

    this.currentGridOptions = {
        selectionRowHeaderColName: 'checkMarkRowHeaderCol',
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        useExternalPagination: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        rowHeight: 26,
        multiSelect: true,
        rowTemplate: '<div ng-dblclick="grid.appScope.$ctrl.rowDoubleClicked(row)" ' +
        'ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ui-grid-cell> ' +
        '</div>',
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged($scope, this.gridRowSelectionChangedHandler);
        }
    };

    this.gridRowSelectionChangedHandler = (row: JS5Object) => {
        if (row.isSelected) {
            this.selectedMetadataRows.push(row.entity);
        } else {
            let index = this.selectedMetadataRows.indexOf(row.entity);
            this.selectedMetadataRows.splice(index, 1);
        }
    };

    this.toggleRows = (evt: JS5Object) => {
        if (this.gridApi.selection.selectAll) {
            this.gridApi.selection.clearSelectedRows(evt);
            this.gridApi.selection.selectAll = false;
        } else {
            this.gridApi.selection.selectAllVisibleRows(evt);
            this.gridApi.selection.selectAll = true;
        }

        this.selectedMetadataRows = this.gridApi.selection.getSelectedRows();
    };

    this.rowDoubleClicked = (row: JS5Object) => {
        showMetadataItemModal(row.entity);
    };


    //=================//
    // Toolbar Buttons //
    //=================//

    this.saveMetadataItem = (prop: JS5Object) => {
        this.loadingIndicator.show = true;
        if (prop.id < 0) {
            delete prop.id;
        }
        prop.required = !!prop.required;
        prop.mvpd = this.showMVPD;

        MetadataEditService.saveProperty(prop).then(() => {
            this.queryForGridData();
        });
    };

    const showMetadataItemModal = (row?: JS5Object) => {
        ModalService.showMetadataItemEditorModal(
            this.ownerClass,
            _.get(row, 'id', -1),
            this.showMVPD,
            this.showConversion,
            this.saveMetadataItem
        );
    };

    const openAddMetadataItemModal = () => {
        showMetadataItemModal();
    };

    const openEditMetadataItemModal = () => {
        showMetadataItemModal(this.selectedMetadataRows[0]);
    };

    const confirmDeleteMetadataItem = () => {
        let title = `Delete ${this.showConversion ? 'Conversion Template Variable' : 'Metadata Item'}`;
        let message = `Are you sure you want to delete this ${this.showConversion ? 'conversion template variable' : 'metadata item'}?`;
        ModalService.showMessageModal({
            messageText: message,
            pullCancelLeft: true,
            title: title,
            windowClass: 'confirm-modal-sm',
            showOK: true
        }, () => {
            let promises: JS5Promise[] = [];
            this.loadingIndicator.show = true;
            angular.forEach(this.selectedMetadataRows, (metadataObject: JS5Object) => {
                let item = MetadataEditService.deleteProperty(metadataObject);
                promises.push(item);
            });
            $q.all(promises).then(() => {
                this.queryForGridData();
            });
        });
    };

    this.toolbarButtonDefs = [
        {
            label: 'New',
            enabled: () => this.selectedMetadataRows.length === 0,
            onClick: openAddMetadataItemModal
        }, {
            label: 'Edit',
            enabled: () => this.selectedMetadataRows.length === 1,
            onClick: openEditMetadataItemModal
        }, {
            label: 'Delete',
            enabled: () => this.selectedMetadataRows.length >= 1,
            onClick: confirmDeleteMetadataItem
        }
    ];

    this.checkMarkCellClicked = (row: JS5Object) => {
        this.saveMetadataItem(row);
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.queryForGridData = () => {
        this.selectedMetadataRows = [];

        return this.getPropertiesPromise()
        .then((data: JS5Object[]) => {
            this.currentGridOptions.data = data;
            this.loadingIndicator.show = false;
        });
    };

    this.$onInit = () => {
        this.selectedMetadataRows = [];
        this.loadingIndicator = {
            backdrop: true,
            show: true,
            title: 'Working',
            message: 'Please wait...'
        };

        this.currentGridOptions.columnDefs = this.columnDefs;
        this.queryForGridData();
    };
}

angular.module('prism-ui.metadataItems').component(
    'metadataItemsGrid',
    {
        bindings: {
            columnDefs: '=',
            getPropertiesPromise: '&',
            headerTitle: '=',
            ownerClass: '=',
            showMVPD: '=',
            showConversion: '=',
        },
        controller: MetadataItemsGridController,
        templateUrl: 'system/metadata/grid/metadata-items-grid-template.html'
    });
